import React from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import commonStyles from "../commonStyles.module.scss";

export const DetailsSectionDivider = ({
    className,
}: {
    className?: string;
}) => (
    <hr className={classNames(commonStyles.detailsSectionDivider, className)} />
);

DetailsSectionDivider.defaultProps = {
    className: undefined,
};
